import React, { useEffect, useRef } from "react";

import Button from "../ui/button/Button";
import styles from "./Popover.module.scss";

type PopoverProps = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  onUpdate?: () => void;
};

const Popover: React.FC<PopoverProps> = ({ isOpen, onClose, onDelete }) => {
  const popoverRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.popover} ref={popoverRef}>
      <Button noHover className={styles.popoverItem} onClick={onDelete}>
        Revoke Key
      </Button>
    </div>
  );
};

export default Popover;
